<!--
 * @Author: your name
 * @Date: 2020-10-14 17:27:26
 * @LastEditTime: 2021-12-22 09:35:17
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/venue-home/component/Terms/index.vue
-->
<style lang="sass" scoped>
.terms_dialog
  height: 90vh
  width: 90vw
  position: fixed
  top: 5vh
  left: 5vw
  z-index: 4
  overflow-y: auto
  padding: 24px
  background: #fff
  border-radius: 10px
  box-sizing: border-box

.origin_terms_dialog
  height: 0
  width: 0
  position: fixed
  top: 5vh
  left: 5vw
  z-index: 4
  overflow: hidden
  background: #fff
  border-radius: 10px

.white
  position: fixed
  height: 100%
  width: 100%
  top: 0
  z-index: 3
  background: rgba(0,0,0,0.5)
  transition: background .5s ease

.origin
  position: fixed
  height: 100%
  width: 100%
  top: 0
  background: rgba(0,0,0,0)
  transition: background .5s ease

.close
  height: 40px
  width: 40px
  display: flex
  justify-content: center
  align-items: center
  position: absolute
  top: 0
  right: 0
  z-index: 4
  border-radius: 50%

.terms_content
  color: #1f1f1f
  font-size: 14px
  line-height: 1.6

  h1
    margin: 0 0 16px
    font-size: 24px
    color: #222

  h2
    margin: 24px 0 8px
    font-size: 18px
    color: #222

  h3
    margin: 16px 0 8px
    font-size: 16px
    color: #222

  p
    margin: 0 0 12px

  ul, ol
    margin: 0 0 16px 20px
    padding: 0

  li
    list-style: disc

  strong
    font-weight: 700
</style>
<template>
  <div :class="{'origin': !showTermsDialog, 'white': showTermsDialog}">
    <div :class="{'origin_terms_dialog': !showTermsDialog, 'terms_dialog': showTermsDialog}">
      <div class="terms_content">
        <h1>MondoConneX Terms of Use</h1>

        <h2>1. Introduction</h2>
        <p>These Terms of Use (<strong>Terms</strong>) govern your access to and use of the digital ordering technology provided by <strong>MondoConneX Pty Ltd</strong> (ACN 152 918 244) (<strong>Mondo</strong>, <strong>we</strong>, <strong>us</strong>, <strong>our</strong>).</p>
        <p>Our technology includes:</p>
        <ul>
          <li><strong>Mondo Menu:</strong> Our mobile web-based ordering platform (accessed via QR codes).</li>
          <li><strong>Self-Service Kiosks:</strong> Touchscreen ordering terminals located at venues.</li>
          <li><strong>Mondo PocketPOS:</strong> Handheld ordering and payment devices operated by venue staff. (collectively, the <strong>Platforms</strong>).</li>
        </ul>
        <p>By accessing or using the Platforms to view menus or place orders at participating third-party restaurants, cafes, hotels, bars, or airport lounges (<strong>Venues</strong>), you agree to be bound by these Terms.</p>

        <h2>2. Our Role vs The Venue's Role</h2>
        <p>It is important that you understand Mondo's role in your transaction.</p>
        <ul>
          <li><strong>Mondo is the Software Provider:</strong> We provide the technology that connects you to the Venue's Point of Sale (POS) system (e.g., Oracle Simphony). We act as an agent to transmit your order and payment details to the Venue.</li>
          <li><strong>The Venue is the Seller:</strong> The contract for the sale of goods is formed directly between <strong>you and the Venue</strong>. The Venue is solely responsible for:
            <ul>
              <li>The quality, safety, and preparation of food and beverages.</li>
              <li>The accuracy of menu descriptions, photos, and ingredient lists (including allergen information).</li>
              <li>Compliance with liquor licensing laws (including RSA).</li>
              <li>Determining prices and surcharges.</li>
            </ul>
          </li>
        </ul>

        <h2>3. Accounts and Guest Access</h2>
        <ul>
          <li><strong>Mobile & QR Orders:</strong> When using our mobile platforms, you may be required to create an account or your details may be linked to your device to facilitate future orders and digital receipts. You are responsible for maintaining the confidentiality of your device and account details.</li>
          <li><strong>Kiosk Orders:</strong> Transactions processed via Self-Service Kiosks are processed as "Guest" transactions. No permanent account is created, though we may retain transaction data for tax and audit purposes in accordance with our Privacy Policy.</li>
        </ul>

        <h2>4. Orders, Pricing and Payments</h2>
        <ul>
          <li><strong>Placing an Order:</strong> By completing the checkout process on a Kiosk, Mobile Web App, or via a staff member using PocketPOS, you are making an offer to purchase the selected products from the Venue.</li>
          <li><strong>Pricing & Surcharges:</strong> All prices are set by the Venue. The total price may include additional surcharges (e.g., credit card processing fees, weekend or public holiday surcharges). By confirming the transaction, you agree to pay the total amount displayed.</li>
          <li><strong>Payment Processing:</strong> Payments are processed via secure third-party gateways (such as <strong>Fiserv</strong> or <strong>Square</strong>). Mondo does not store full credit card details. You warrant that you are the authorised user of the payment method provided.</li>
          <li><strong>Inventory Discrepancies:</strong> We integrate with the Venue's POS to display stock availability. However, due to technical latency or kitchen pacing, an item displayed as "In Stock" on the Platform may occasionally be unavailable. Mondo is not liable for these discrepancies.</li>
        </ul>

        <h2>5. Refunds and Cancellations</h2>
        <ul>
          <li><strong>Venue Discretion:</strong> As the contract of sale is between you and the Venue, <strong>all requests for refunds, cancellations, or order disputes must be directed to the Venue staff.</strong></li>
          <li><strong>Mondo's Role:</strong> While our system has the technical capability to process a refund back to your card, this action can only be performed <strong>upon instruction from the Venue</strong>. Mondo cannot authorise a refund without Venue approval.</li>
          <li><strong>No "Change of Mind":</strong> Once an order is confirmed and sent to the kitchen, it generally cannot be cancelled.</li>
        </ul>

        <h2>6. Alcohol and Age Verification</h2>
        <ul>
          <li><strong>Legal Age:</strong> You acknowledge that it is illegal to sell alcohol to, or purchase alcohol for, any person under the age of 18 (in Australia) or the relevant legal drinking age in the jurisdiction where the Venue is located.</li>
          <li><strong>Venue Responsibility:</strong> The Venue is responsible for verifying your age. Staff may request ID upon delivery of drinks or at the Kiosk/Counter.</li>
          <li><strong>Refusal of Service:</strong> The Venue reserves the right to refuse service to anyone who appears intoxicated or cannot provide valid ID, even if the order was processed via the Platform. In such cases, refunds are at the Venue's discretion.</li>
        </ul>

        <h2>7. Allergens and Dietary Requirements</h2>
        <ul>
          <li><strong>Warning:</strong> Commercial kitchens handle nuts, gluten, seafood, and other allergens. Cross-contamination can occur.</li>
          <li><strong>Disclaimer:</strong> While Mondo enables Venues to display allergen tags, <strong>we do not verify ingredients.</strong> If you have a severe allergy or intolerance, <strong>do not rely solely on the digital menu.</strong> You must speak to Venue staff directly before ordering. Mondo is not liable for any allergic reactions or adverse health effects arising from your consumption of Venue products.</li>
        </ul>

        <h2>8. Limitation of Liability</h2>
        <p>To the maximum extent permitted by law (including the Australian Consumer Law):</p>
        <ul>
          <li><strong>Service Availability:</strong> We do not guarantee that the Platforms will be uninterrupted or error-free. We are not liable for any loss if the Kiosk or Mobile App is offline during your visit.</li>
          <li><strong>Indirect Loss:</strong> Mondo is not liable for any indirect, special, or consequential loss arising from your use of the Platforms.</li>
          <li><strong>Cap on Liability:</strong> Our total liability to you for any claim arising out of these Terms is limited to the <strong>purchase price of your specific Order</strong>.</li>
        </ul>

        <h2>9. User Conduct</h2>
        <p>You agree not to:</p>
        <ul>
          <li>Misuse or physically damage our Kiosks or hardware.</li>
          <li>Attempt to hack, reverse engineer, or interfere with the software or network security of the Platforms.</li>
          <li>Use the Platforms to purchase goods with a stolen or unauthorised payment method.</li>
        </ul>

        <h2>10. Intellectual Property</h2>
        <p>MondoConneX owns all intellectual property rights in the Platforms, including the software code, user interface, and design. You are granted a limited, non-transferable, revocable licence to use the Platforms solely for the purpose of ordering food and beverages.</p>

        <h2>11. Updates to These Terms</h2>
        <p>We may update these Terms from time to time.</p>
        <ul>
          <li><strong>Notification:</strong> We will provide reasonable notice of material changes (e.g., via a website banner or update prompt).</li>
          <li><strong>Acceptance:</strong> Continued use of the Platforms after the changes take effect constitutes your acceptance of the new Terms.</li>
        </ul>

        <h2>12. Governing Law</h2>
        <p>These Terms are governed by the laws of <strong>Victoria, Australia</strong>. You submit to the exclusive jurisdiction of the courts in Victoria.</p>
      </div>
    </div>
    <div class="close" @click="close">
      <icon size="30" color="#fff">clear</icon>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  props: {
    showTermsDialog: Boolean
  }
})
class TermsDialog extends Vue {
  close() {
    this.$emit('update:showTermsDialog', false)
  }
}

export default TermsDialog
</script>
